import Patients from "../Patients";

export default function Prescriptions() {
  return (
    <>
      <Patients heading={"Prescriptions"} />
    </>
  );
}
